import type { UseMutationResult } from '@tanstack/react-query';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { showErrorToast, showSuccessToast } from '../../../utils/toastUtils';
import { getResourceKey } from '../../../utils/utils';
import { type TalkingPointDto, type TalkingPointUpdateDto, updateTalkingPoint } from '../../generated/client';
import { queryKeys } from '../../query-keys';

export const useUpdateTalkingPoint = (): UseMutationResult<TalkingPointDto, AxiosError, TalkingPointUpdateDto> => {
    const { t } = useTranslation();
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload) => {
            const updatedPayload: TalkingPointUpdateDto = { ...payload, key: getResourceKey(payload.name.EN) };

            return updateTalkingPoint({ path: { id: updatedPayload.id }, body: updatedPayload }).then((result) => result.data!);
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.talkingPoints() });
            showSuccessToast(t('successActionGeneric'));
        },
        onError: (error) => showErrorToast({ error, userMessage: t('failureActionGeneric') }),
    });
};
